import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { onErrorHandler } from './handlers';
import { signoutAndRedirectToLogin } from './customer';
import { deleteAuthfrontCookiesAndRedirectToHome } from '../utils/custom';

declare const window: any;

export const loqateApi = createApi({
    reducerPath: 'loqateApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '',
        prepareHeaders: (headers) => {
            return headers
        },
    }),
    tagTypes: ['loqate'],
    endpoints: (builder) => ({
        getRecommendAddress: builder.mutation({
            query: ({ ...data }) => ({
                url: `${window.Config?.LOQATE_API_ENDPOINT}` ?? 'https://api.addressy.com/Cleansing/International/Batch/v1.00/json4.ws',
                method: 'POST',
                body: {
                    'key': window.Config?.LOQATE_API_KEY ?? 'AW13-JF33-CD54-WZ83',
                    ...data,
                }
            }),
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data;
                }
                catch (error) {
                    dispatch(onErrorHandler({operation: 'loqate getRecommendAddress', err: JSON.stringify(error), errMsg: 'Error: while populating / verifying Address', api: `${window.Config.LOQATE_API_ENDPOINT}`}));
                }
            }
        }),
        updateLoqateAddressField: builder.mutation({
            query: ({ customerId, loqateFieldObj }) => {
                let authHeader = window.np.getMcpAuthHeader();
                let requestHeader = { ...authHeader, 'x-api-key' : window.Config?.NP_API_KEY_CLIENT_JS ?? ''}
                return{
                    url: `${window.Config?.UPDATE_CUSTOMER_CUSTOM_FILED}${customerId}/customfield` ?? `https://npr-customer.api.pens.com/v1/customer/address/${customerId}/customfield`,
                    method: 'POST',
                    headers : requestHeader,
                    body: loqateFieldObj
                }
            },
            async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
                try {
                    const { data } = await queryFulfilled;
                    return data;
                }
                catch (error: any) {
                    console.log(error);                  
                    dispatch(onErrorHandler({operation: 'Update Loqate Custom Fields' , err: JSON.stringify(error), errMsg: 'Error: while updating loqate custom field ', api: 'v1/customer/address/customfield'}));
                    if (error?.error?.status === 403 && error?.error?.data?.message === window.MCP_AUTH_CONSTANT.FORBIDDEN_ERROR_MESSAGE) {
                        if(window.authfrontSDK.isSignedIn()){
                            const email = sessionStorage.getItem('np.emailAddress') || '';
                            const state : any = getState();
                            const currentPage = state.applicationState.currentPage;
                            signoutAndRedirectToLogin('INVALID_SESSION',email, true, currentPage);
                        }else{
                            deleteAuthfrontCookiesAndRedirectToHome();
                        }
                    }
                }
            }
        }),
        getEmailValidated: builder.query({
            query: ({ email }) => ({
                url: `${window.Config?.EMAIL_TLD_VALIDATION_API_ENDPOINT ?? 'https://npr-email-validation.api.pens.com/v1/validate-email'}`,
                params: { email: email, timeout: 15000 },
                headers : { 'x-api-key' : window.Config?.NP_API_KEY_CLIENT_JS ?? 'NSjMi38PBJ6s1rvNMA9FKO6FRn2iDd95bEDoaij8'},
                method: 'GET'
            }),
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    return data;
                }
                catch (error) {
                    dispatch(onErrorHandler({operation: 'loqate getEmailValidated', err: JSON.stringify(error), errMsg: 'Error: while validating email', api: `${window.Config.EMAIL_TLD_VALIDATION_API_ENDPOINT}`}));     
                }
            }
        }),
    }),
})

export const {
    useGetRecommendAddressMutation,
    useUpdateLoqateAddressFieldMutation,
    useGetEmailValidatedQuery
} = loqateApi;